import * as Phaser from 'phaser'
import { WorldScene } from './scenes/WorldScene'
import { detectPointer } from './input/capability'
import { JoystickSource } from './input/JoystickSource'

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: '#F6EFE2',
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: { debug: false },
  },
  scene: [WorldScene],
})

// Attach virtual joystick on touch devices after the scene is ready.
game.events.once(Phaser.Core.Events.READY, () => {
  const world = game.scene.getScene('world') as WorldScene
  world.events.once('create', () => {
    if (detectPointer() === 'coarse') {
      const container = document.getElementById('hud')
      if (container) {
        container.style.pointerEvents = 'auto'
        world.inputSystem.register(new JoystickSource(container))
      }
    }
  })
})

export { game }
